import api from "../index";

/**
 * Get user's salons (workspaces)
 */
export const getUserSalons = async () => {
  try {
    const response = await api.get("/user/salons");
    return response.data;
  } catch (error) {
    console.error("Error fetching user salons:", error);
    throw error;
  }
};

/**
 * Switch user's current salon (workspace)
 */
export const switchSalon = async (salonId) => {
  try {
    // Create a custom config that overrides the salon context
    const config = {
      params: {
        salon_id: salonId,
      },
    };

    const response = await api.post(
      "/user/switch-salon",
      {
        salon_id: salonId,
      },
      config,
    );
    return response.data;
  } catch (error) {
    console.error("Error switching salon:", error);
    throw error;
  }
};

/**
 * Get current salon context
 */
export const getCurrentSalon = async (salonId = null) => {
  try {
    const params = {};
    const headers = {};

    // Add salon ID to query parameters and headers if provided
    if (salonId) {
      params.salon_id = salonId;
      headers["x-salon-id"] = salonId;
    }

    const response = await api.get("/user/current-salon", { params, headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching current salon:", error);
    throw error;
  }
};

/**
 * Accept an invitation to join a salon
 */
export const acceptInvitation = async (salonId, passcode) => {
  try {
    const response = await api.post("/user-invitations/accept", {
      salon_id: salonId,
      passcode,
    });
    return response.data;
  } catch (error) {
    console.error("Error accepting invitation:", error);
    throw error;
  }
};
